























































































































































































import {
    computed,
    defineComponent,
    onMounted,
    ref,
    watch
} from "@vue/composition-api";
import useWeather from "@/store/services/weather.service";
import { alarm } from "@/store";
import { ILocationFromParticle } from "@/models/AlarmStatus";
import { WeatherModel } from "@/models/WeatherModel";
export default defineComponent({
    setup() {
        const isLoading = ref(false);
        const loadingLabel = ref("Fetching weather data...");
        const { getCurrentWeather } = useWeather();
        const currentWeather = ref<WeatherModel>(null);

        function timeConverter(UNIX_timestamp) {
            var a = new Date(UNIX_timestamp * 1000);
            var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            var day = days[a.getDay()];
            var hour = a.getHours().toString().padStart(2, "0");
            var min = a.getMinutes().toString().padStart(2, "0");
            var time = day + ', ' + hour + ':' + min;
            return time;
        }

        function timetoDayConverter(UNIX_timestamp) {
            var a = new Date(UNIX_timestamp * 1000);
            var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            return days[a.getDay()];
        }

        function getCardinalDirection(angle) {
            // Added the VS15 using the Unicode escape sequence to not use Emoji
            const directions = [
                'N \u2B06\uFE0E',
                'NE \u2197\uFE0E',
                'E \u27A1\uFE0E',
                'SE \u2198\uFE0E',
                'S \u2B07\uFE0E',
                'SW \u2199\uFE0E',
                'W \u2B05\uFE0E',
                'NW \u2196\uFE0E'
            ];
            // Added the VS15 using the Unicode escape sequence to use Emoji
            const emoji_directions = [
                'N \u2B06\uFE0F',
                'NE \u2197\uFE0F',
                'E \u27A1\uFE0F',
                'SE \u2198\uFE0F',
                'S \u2B07\uFE0F',
                'SW \u2199\uFE0F',
                'W \u2B05\uFE0F',
                'NW \u2196\uFE0F'
            ];
            return emoji_directions[Math.round(angle / 45) % 8];
        }

        const forecast = computed<object>(() => {
            let comingWeather = [];
            if (currentWeather.value) {
                for (var i = 0; i < 7; i++) {
                    let day = timetoDayConverter(currentWeather.value.daily[i].dt);
                    let icon = require(`@/assets/wicons/${currentWeather.value.daily[i].weather[0].icon}@2x.svg`);
                    let temp = Math.round(currentWeather.value.daily[i].temp.day).toString().trim() + "°C / " + Math.round(currentWeather.value.daily[i].temp.night).toString().trim() + "°C";
                    let rain = (currentWeather.value.daily[i].pop * 100).toFixed(0) + "%";
                    let description = currentWeather.value.daily[i].weather[0].description.charAt(0).toUpperCase() + currentWeather.value.daily[i].weather[0].description.slice(1);
                    let windSpeed = currentWeather.value.daily[i].wind_speed.toString().trim() + "m/s";
                    let windDeg = getCardinalDirection(currentWeather.value.daily[i].wind_deg);
                    let dayWeather = { day, icon, temp, rain, windSpeed, windDeg, description };
                    comingWeather.push(dayWeather);
                }
            }
            return comingWeather;
        });

        const currentTime = computed<string>(() => {
            return currentWeather.value ? timeConverter(currentWeather.value.current.dt) : "";
        });

        const temperature = computed<string>(() => {
            return currentWeather.value ? Math.round(currentWeather.value.current.temp).toString().trim() + "°C" : "";
        });
        const feelsLike = computed<string>(() => {
            return currentWeather.value ? Math.round(currentWeather.value.current.feels_like).toString().trim() + "°C" : "";
        });
        const humidity = computed<string>(() => {
            return currentWeather.value ? currentWeather.value.current.humidity.toString().trim() + "%" : "";
        });
        const windSpeed = computed<string>(() => {
            return currentWeather.value ? currentWeather.value.current.wind_speed.toString().trim() + "m/s" : "";
        });
        const windDeg = computed<string>(() => {
            return currentWeather.value ? getCardinalDirection(currentWeather.value.current.wind_deg) : "";
        });

        const weatherMainText = computed<string>(() => {
            return currentWeather.value ? currentWeather.value.current.weather[0].main.toString().trim() : "";
        });

        const weatherDescriptionText = computed<string>(() => {
            if (currentWeather.value) {
                const mainWeather = currentWeather.value.current.weather[0].description.toString().trim();
                return mainWeather.charAt(0).toUpperCase() + mainWeather.slice(1);
            } else {
                return "";
            }
        });

        const iconurl = computed(() => {
            if (currentWeather.value) {
                return require(`@/assets/wicons/${currentWeather.value.current.weather[0].icon}@2x.svg`);
            } else {
                return "";
            }
        });
        const location = computed<ILocationFromParticle | null>(() => {
            return alarm.lastKnownLocation ? alarm.lastKnownLocation : null;
        });
        const getWeather = (gps: ILocationFromParticle | null) => {
            isLoading.value = true;
            const lat = gps ? gps.location.geometry.coordinates[1].toString() : "0";
            const lon = gps ? gps.location.geometry.coordinates[0].toString() : "0";

            const startTime = Date.now();

            getCurrentWeather(lat, lon).then((result: WeatherModel) => {
                const elapsed = Date.now() - startTime;
                const delay = Math.max(0, 500 - elapsed);

                setTimeout(() => {
                    currentWeather.value = result;
                    isLoading.value = false;
                }, delay);
            });
        };

        watch(() => location.value, getWeather);
        onMounted(() => {
            getWeather(location.value);
        });
        return {
            forecast,
            currentTime,
            temperature,
            feelsLike,
            humidity,
            windSpeed,
            windDeg,
            weatherMainText,
            weatherDescriptionText,
            iconurl,
            loadingLabel,
            isLoading
        };
    }
});
